import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchPartnerCaller = async ({ partnerCode, phoneNumber }: { partnerCode: string; phoneNumber: string }) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      partnerCode,
      phoneNumber,
    },
    query: graphql(`
      query PartnerCaller($partnerCode: String!, $phoneNumber: String!) {
        partnerCaller(partnerCode: $partnerCode, phoneNumber: $phoneNumber) {
          callerId
          partnerId
          rides
          credits
          notes
          defaultRideAllowanceTier
          defaultRideAllowanceAmount
          preAuthorizationNumber
          suspensionDate
          externalPartnerCallerId
          partnerEmergencyContact
          partnerProgramManager
          memberGroups
        }
      }
    `),
  });

  return response.data.partnerCaller;
};
